import { useEffect } from "react";
import { useChannelIOApi } from "react-channel-plugin";
/** solvookApp 웹뷰에서 채널톡 버튼 숨김 (autoBoot=false 방어 로직) */ const useHideChannelTalk = ()=>{
    const { hideChannelButton , showChannelButton  } = useChannelIOApi();
    useEffect(()=>{
        hideChannelButton();
        return ()=>{
            showChannelButton();
        };
    }, [
        hideChannelButton,
        showChannelButton
    ]);
};
export default useHideChannelTalk;
